import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "reactstrap";
const EditConfirm = props => {
  let { open } = props;
  return (
    <Dialog
      open={open}
      onClose={() => props.onCancel()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          width: 365,
          background: "linear-gradient(60deg, #3769DA, #E2E3E5)",
          color: "white"
        }}
      >
        {"Do you want to Edit it!"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ padding: 24, paddingBottom: 0, fontWeight: "bold" }}
          className="color-danger"
        >
          Are you sure!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.onCancel()}
          color="primary"
          className="bg-light text-dark"
        >
          Cancel
        </Button>
        <Button
          onClick={e => props.onConfrim()}
          color="success"
          className="bg-success"
          autoFocus
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditConfirm;



// WEBPACK FOOTER //
// ./src/components/alert/EditAlert.jsx